import { lazy } from "react";
// Note: make sure path is in lower case

export const routes = {
  billing: {
    path: "/billing-admin/:tab?/:subtab?",
    element: lazy(() => import("../../pages/BillingAdmin")),
  },
  billingAdminLegacyRedirect: {
    path: "/billing/*",
    element: lazy(() => import("../BillingAdminLegacyRedirect")),
  },
  billingModule: {
    // for circadia internal users (account manager group) and MDs (BillingPractitioner group)
    path: "/billing",
    element: lazy(() => import("../../pages/BillingModule")),
  },
  changeFacility: {
    path: "/change-facility",
    element: lazy(() => import("../../pages/ChangeFacility")),
  },
  vitalSync: {
    path: "/vitals-ai",
    element: lazy(() => import("../../pages/VitalSync")),
  },
  vitalSyncHistory: {
    path: "/vitals-ai/history",
    element: lazy(
      () => import("../../pages/VitalSync/PCCSubmissionHistoryPage")
    ),
  },
  search: {
    path: "/search",
    element: lazy(() => import("../../pages/Search")),
  },
  clinical: {
    path: "/clinical",
    element: lazy(() => import("../../pages/CareCoordination")),
  },
  trends: {
    path: "/trends",
    element: lazy(() => import("../../pages/Trends")),
  },
  patientProfile: {
    path: "/patient-profile/:patientId",
    element: lazy(() => import("../../pages/PatientProfile")),
  },
  patient: {
    path: "/patient/:patientId/:tab?",
    element: lazy(() => import("../../pages/Patient")),
  },
  patientFacility: {
    path: "/patient/:patientId/clinic/:clinicId",
    element: lazy(() => import("../../pages/Patient")),
  },
  patientForRedirect: {
    path: "/patient/:patientId/:slug1/:slug2/:slug3",
    element: lazy(() => import("../../pages/Patient")),
  },
  compassusPatient: {
    path: "/compassus-patient/:patientId/:tab?",
    element: lazy(() => import("../../pages/CompassusPatient")),
  },

  SBARReportPage: {
    path: "/sbar-report/:patientId/:reportId",
    element: lazy(() => import("../../pages/SBARReportPage")),
  },
  addBedExitAlert: {
    path: "/manage-alert/:residentId/add",
    element: lazy(() => import("../../pages/EditBedExitAlerts")),
  },
  exitBedExitAlert: {
    path: "/manage-alert/:patientId/edit",
    element: lazy(() => import("../../pages/EditManageBedExitAlert")),
  },
  patientProfileFacility: {
    path: "/patient-profile/:patientId/clinic/:clinicId",
    element: lazy(() => import("../../pages/PatientProfile")),
  },
  patientProfileForRedirect: {
    path: "/patient-profile/:patientId/:slug1/:slug2/:slug3",
    element: lazy(() => import("../../pages/PatientProfile")),
  },
  changePassword: {
    path: "/change-password",
    element: lazy(() => import("../../pages/ChangePassword")),
  },
  changePin: {
    path: "/change-pin",
    element: lazy(() => import("../../pages/ChangePin")),
  },
  watchlist: {
    path: "/watchlist",
    element: lazy(() => import("../../pages/Watchlist")),
  },
  reports: {
    path: "/reports",
    element: lazy(() => import("../../pages/Reports")),
  },
  bedexits: {
    path: "/bedexits",
    element: lazy(() => import("../../pages/BedExitEvents")),
  },
  riskReport: {
    path: "/risk-report",
    element: lazy(() => import("../../pages/Reports/AIRiskReportPage")),
  },
  riskReport2: {
    path: "/public/risk-report",
    element: lazy(() => import("../../pages/Reports/AIRiskReportPage")),
  },
  telehealthCall: {
    path: "/telehealth/call/:telehealthSessionId",
    element: lazy(() => import("../../pages/TelehealthCall")),
  },
  telehealth: {
    path: "/telehealth",
    element: lazy(() => import("../../pages/Telehealth")),
  },
  dailyReport: {
    path: `/daily-report/:dailyReportId`,
    element: lazy(() => import("../../pages/Reports/DailyReport")),
  },
  myFacility: {
    path: "/my-facility",
    element: lazy(() => import("../../pages/MyFacility")),
  },
  eSignReview: {
    path: "/my-facility/review/:consentStatus/:residentId",
    element: lazy(() => import("../../pages/MyFacility/ConsentESignReview")),
  },
  eSignForm: {
    path: "/my-facility/form/:consentStatus/:residentId",
    element: lazy(() => import("../../pages/MyFacility/ConsentESignForm")),
  },
  alertDetails: {
    path: "/alert-details/:alertId/:residentId",
    element: lazy(() => import("../../pages/CareCoordination/AlertDetails")),
  },

  alertDetailHash: {
    path: "#/alert-details/:alertId/:residentId",
    element: lazy(() => import("../../pages/CareCoordination/AlertDetails")),
  },
  contactSupport: {
    path: "/contact-support",
    element: lazy(() => import("../../pages/ContactSupport")),
  },

  intendedUse: {
    path: "/intended-use",
    element: lazy(() => import("../../pages/IntendedUser")),
  },

  faq: {
    path: "/faq",
    element: lazy(() => import("../../pages/Faq")),
  },

  feedback: {
    path: "/feedback",
    element: lazy(() => import("../../pages/Feedback")),
  },
  floorSettings: {
    path: "/floor-settings",
    element: lazy(() => import("../../pages/FloorSettings")),
  },
  notificationSettings: {
    path: "/notification-settings",
    element: lazy(() => import("../../pages/NotificationSettings")),
  },
  facilityInformation: {
    path: "/facility-information",
    element: lazy(() => import("../../pages/FacilityInformation")),
  },
  reportAProblem: {
    path: "/reportAProblem",
    element: lazy(() => import("../../pages/ReportAProblem")),
  },
  rateApp: {
    path: "/rateApp",
    element: lazy(() => import("../../pages/RateApp")),
  },
  privacyPolicy: {
    path: "/privacyPolicy",
    element: lazy(() => import("../../pages/PrivacyPolicy")),
  },
  dashboard: {
    path: "/dashboard",
    element: lazy(() => import("../../pages/Dashboard")),
  },
  settings: {
    path: "/settings",
    element: lazy(() => import("../../pages/Settings")),
  },
  bedExitPatientChart: {
    path: "/bed-exit/patient/:patientId/clinic/:clinicId",
    element: lazy(() => import("../../pages/PatientProfile")),
  },
  // bedExitAlert: {
  //   path: "bedexit-alerts",
  //   element: lazy(() => import("../../pages/BedExitAlerts")),
  // },
  editBedExitAlert: {
    path: "/edit-bed-exit-alerts/:residentId",
    element: lazy(() => import("../../pages/EditBedExitAlerts")),
  },
  editBedExitAlertForSettings: {
    path: "/bed-exit-settings",
    element: lazy(() => import("../../pages/EditBedExitAlertsForSettings")),
  },
  alertChimeScreen: {
    path: "/bed-exit/chime/:residentId/:roomName/:clinicId/:sound",
    element: lazy(() => import("../../pages/AlertChime")),
  },
  escalationChimeScreen: {
    path: "/escalation/chime/:residentId/:roomName/:clinicId/:sound/:escalationId",
    element: lazy(() => import("../../pages/EscalationChime")),
  },
  flagChimeScreen: {
    path: "/flag/chime/:residentId/:roomName/:clinicId/:sound/:psnFlagId",
    element: lazy(() => import("../../pages/FlagChime")),
  },
  SummaryScreen: {
    path: "/summary",
    element: lazy(() => import("../../pages/SummaryScreen")),
  },
  IPVNoteScreen: {
    path: "/ipv",
    element: lazy(() => import("../../pages/IPVNote")),
  },
  Insights: {
    path: "/insights",
    element: lazy(() => import("../../pages/Insights")),
  },
  motionAndExits: {
    path: "/motion-and-exits",
    element: lazy(() => import("../../pages/BedExitEvents")),
  },
  intercom: {
    // Renders the VoIP calling directory for users with intercom access
    // (see hasIntercomAccess), otherwise the sales card. Supports deep links
    // for bed-exit notifications via /intercom?patientId=.
    path: "/intercom",
    element: lazy(() => import("../../pages/Features/IntercomPage")),
  },
  iq: {
    path: "/iq",
    element: lazy(() => import("../../pages/Features/IQPage")),
  },
  intake: {
    path: "/intake",
    element: lazy(() => import("../../pages/Features/IntakePage")),
  },
  mds: {
    path: "/mds",
    element: lazy(() => import("../../pages/Features/MDSPage")),
  },
  medRecAI: {
    path: "/medications",
    element: lazy(() => import("../../pages/MedRecAI")),
  },
  medRecPdfViewer: {
    path: "/medications/pdf-viewer",
    element: lazy(() => import("../../pages/MedRecAI/PdfViewer")),
  },
  rtBilling: {
    path: "/rt/billing",
    element: lazy(() => import("../../pages/RTBilling")),
  },
  rtBillingCycle: {
    path: "/rt/billing/cycle",
    element: lazy(() => import("../../pages/RTBillingCycle")),
  },
  voice: {
    path: "/voice",
    element: lazy(() => import("../../pages/Features/VoicePage")),
  },
  userInfo: {
    path: "/user-info",
    element: lazy(() => import("../../pages/UserInfo")),
  },
  newVisit: {
    path: "/visits/new",
    element: lazy(() => import("../../pages/CompassusVisits/NewVisit")),
  },
  visitNotes: {
    path: "/visit-notes",
    element: lazy(() => import("../../pages/CompassusVisits")),
  },
  visitNote: {
    path: "/visit-notes/note/:noteId",
    element: lazy(() => import("../../pages/CompassusVisits/VisitNotePage")),
  },
  visitCalendar: {
    path: "/visit-notes/calendar",
    element: lazy(() => import("../../pages/CompassusVisits/VisitsCalendar")),
  },
  pdfViewer: {
    path: "/visit-notes/pdf-viewer",
    element: lazy(() => import("../../pages/CompassusVisits/PdfViewer")),
  },
  logout: {
    path: "/logout",
    element: lazy(() => import("../../pages/LogoutPage")),
  },
  npScheduling: {
    path: "/np-scheduling",
    element: lazy(() => import("../../pages/NpSchedulingApp")),
  },
  npProductivity: {
    path: "/np-productivity",
    element: lazy(() => import("../../pages/CompassusProductivity")),
  },
  npProductivityV2: {
    path: "/compassus-insights",
    element: lazy(() => import("../../pages/CompassusProductivityV2")),
  },
  npDashboard: {
    path: "/np-dashboard",
    element: lazy(
      () => import("../../pages/CompassusProductivity/NpDashboard")
    ),
  },
  workflowsEligibility: {
    path: "/workflows/eligibility",
    element: lazy(() => import("../../pages/CompassusEligibility")),
  },
  neo: {
    path: "/neo",
    element: lazy(() => import("../../pages/Neo")),
  },
  neoWorkflows: {
    path: "/neo-workflows/:workflowId?",
    element: lazy(() => import("../../pages/NeoWorkflows")),
  },
  productUtilizationDashboard: {
    // Superadmin-only (Cognito `sa` group). Access is enforced by
    // SuperadminRouteGuard (URL unreachable for non-sa) and again server-side
    // by the /product-utilization/* endpoints.
    path: "/product-utilization-dashboard",
    element: lazy(() => import("../../pages/ProductUtilizationDashboard")),
  },
  npProductivityTimeline: {
    // Superadmin-only (Cognito `sa` group). Access is enforced by
    // SuperadminRouteGuard (URL unreachable for non-sa) and again server-side
    // by the /np-productivity/* endpoints.
    path: "/np-productivity-timeline",
    element: lazy(() => import("../../pages/NpProductivityTimeline")),
  },
  overview: {
    path: "/overview",
    element: lazy(() => import("../../pages/DashboardOverview")),
  },
  oasisPdf: {
    path: "/oasis-pdf/:patientId",
    element: lazy(() => import("../../pages/OasisPdf")),
  },
  deviceOrders: {
    path: "/device-orders",
    element: lazy(() => import("../../pages/DeviceOrders")),
  },
  // ⛔️ADD MORE ROUTE ABOVE THIS LINE⛔️
  redirectElementStar: {
    path: "*",
    element: lazy(() => import("./redirectElement")),
  },
  redirectElement: {
    path: "",
    element: lazy(() => import("./redirectElement")),
  },
  termsOfUse: {
    path: "/terms-of-use",
    element: lazy(() => import("../../pages/TermsOfUse")),
  },
  evaluationAndManagement: {
    path: "/navigator",
    element: lazy(() => import("../../pages/Navigator")),
  },
  compassusNavigator: {
    path: "/compassus-navigator",
    element: lazy(() => import("../../pages/CompassusNavigator")),
  },
} as const;
